// Carousel functionality for testimonials block

(function () {
    var carousel = document.querySelector('.shs-testimonials-carousel');
    if (!carousel) return;
    var track = carousel.querySelector('.shs-testimonials-track');
    var slides = track ? track.querySelectorAll('.shs-testimonial-slide') : [];
    var prev = carousel.querySelector('.shs-testimonial-nav.prev');
    var next = carousel.querySelector('.shs-testimonial-nav.next');
    var slideCount = slides.length;
    if (slideCount < 2) return; // No need for carousel if only one slide

    // Clone first and last slides for seamless looping
    var firstClone = slides[0].cloneNode(true);
    var lastClone = slides[slideCount - 1].cloneNode(true);
    firstClone.classList.add('clone');
    lastClone.classList.add('clone');
    track.appendChild(firstClone);
    track.insertBefore(lastClone, slides[0]);

    var allSlides = track.querySelectorAll('.shs-testimonial-slide');
    var current = 1; // Start at the first real slide
    var transitioning = false;

    function setTransition(enable) {
        track.style.transition = enable ? 'transform 0.5s cubic-bezier(0.4,0,0.2,1)' : 'none';
    }

    function show(index, withTransition) {
        if (!track) return;
        setTransition(withTransition !== false);
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        allSlides.forEach(function (slide, i) {
            slide.setAttribute('aria-hidden', String(i !== index));
        });
    }

    function advance(step) {
        if (transitioning) return;
        transitioning = true;
        current += step;
        show(current, true);
    }

    // Handle seamless looping on transition end
    track.addEventListener('transitionend', function () {
        if (current === 0) {
            setTransition(false);
            current = slideCount;
            show(current, false);
        } else if (current === slideCount + 1) {
            setTransition(false);
            current = 1;
            show(current, false);
        }
        transitioning = false;
    });

    var timer = setInterval(function () { advance(1); }, 5000);
    function reset() {
        clearInterval(timer);
        timer = setInterval(function () { advance(1); }, 5000);
    }

    if (prev) {
        prev.addEventListener('click', function () { advance(-1); reset(); });
    }
    if (next) {
        next.addEventListener('click', function () { advance(1); reset(); });
    }

    // Set initial position to first real slide
    show(current, false);
})();
